import React from 'react'
import { useTable, useGlobalFilter } from 'react-table'
import './productsTable.css'
import { FormatMoney } from 'Utils/functions'
import { ArrowDownUp } from 'react-bootstrap-icons'
import { t } from 'i18next'

function ProductsTable({
  data,
  columns,
  isProductPage,
  hideFooter,
  totals,
  isToolTip,
  showDiscount,
}) {
  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter
  )

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    tableInstance

  return (
    <>
      <table className="table-products-quote-style" {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, i) => (
                <th
                  key={i}
                  {...column.getHeaderProps({
                    style: {
                      width: column.width,
                    },
                  })}>
                  <div className="detail-products-header-table-container">
                    <div className="detail-products-header-text">
                      {column.render('Header')}
                    </div>
                    {column.arrowOrderEnabled ? (
                      <ArrowDownUp className="arrow-products-invoice-style" />
                    ) : null}
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, index) => {
            prepareRow(row)
            return (
              <tr
                key={index}
                {...row.getRowProps({
                  style:
                    rows.length <= index + 1
                      ? {
                          borderBottom: '1px solid #E1E1E1',
                          backgroundColor: '#fff',
                        }
                      : { borderBottom: 'none' },
                })}>
                {row.cells.map((cell, i) => (
                  <td
                    key={i}
                    {...cell.getCellProps({
                      style: {
                        width: cell.column.width,
                        padding: '21px 2px',
                      },
                    })}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                      }}>
                      {cell.column.Header === 'Precio total' ||
                      cell.column.Header === 'Precio unitario' ? (
                        <div className="detail-products-table-text">
                          {'$ ' +
                            (cell.value
                              ? FormatMoney(cell.value, true, 2)
                              : '0.00')}
                        </div>
                      ) : cell.column.Header === 'Referencia' ? (
                        <div className="detail-products-table-text">
                          {cell.render('Cell')}
                        </div>
                      ) : cell.column.Header === 'Descuento' ? (
                        <div className="detail-products-table-text">
                          {'$ ' +
                            (cell.value && showDiscount
                              ? FormatMoney(cell.value, true, 2)
                              : '0.00')}
                        </div>
                      ) : (
                        <div className="detail-products-table-text">
                          {cell.render('Cell')}
                        </div>
                      )}
                    </div>
                  </td>
                ))}
              </tr>
            )
          })}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={columns.length - 2}></td>
            <td>
              <div className="container-totals">
                <div className="detail-products-table-description-totals justify-content-end">
                  {t('DETAIL_DOCUMENTS_T.SUB_TOTAL')}
                </div>
              </div>
            </td>
            <td>
              <div className="container-totals">
                <div className="detail-products-table-description-totals justify-content-end">
                  ${FormatMoney(totals[0]?.SubTotal, true, 2)}
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={columns.length - 2}></td>
            <td>
              <div className="container-totals">
                <div className="detail-products-table-description-totals justify-content-end">
                  {t('DETAIL_DOCUMENTS_T.DISCOUNT')}
                </div>
              </div>
            </td>
            <td>
              <div className="container-totals">
                <div
                  className="detail-products-table-description-totals justify-content-end"
                  data-testid="text-discount-value">
                  $
                  {FormatMoney(showDiscount ? totals[0]?.Discount : 0, true, 2)}
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={columns.length - 2}></td>
            <td>
              <div className="container-totals">
                <div className="detail-products-table-description-totals justify-content-end ">
                  {t('DETAIL_DOCUMENTS_T.ITBMS')}
                </div>
              </div>
            </td>
            <td>
              <div className="container-totals">
                <div className="detail-products-table-description-totals justify-content-end">
                  ${FormatMoney(totals[0]?.Tax, true, 2)}
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={columns.length - 2}></td>
            <td>
              <div className="container-totals font-weight">
                <div className="detail-products-table-description-totals justify-content-end">
                  {t('DETAIL_DOCUMENTS_T.TOTAL')}
                </div>
              </div>
            </td>
            <td>
              <div className="container-totals font-weight">
                <div className="detail-products-table-description-totals justify-content-end">
                  ${FormatMoney(totals[0]?.Total, true, 2)}
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </>
  )
}

export default ProductsTable
